<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination 
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler"
        @saveTags="saveTagsHandler" />
    </template>
    <template slot="table-component">
    <kendo-grid-component
        ref="grid"
        v-model="selected"
        value-key="idProducto"
        :id-vista="idVista"
        :spanish="spanish"
        :data='data'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @actionclick='openPath'
        @datastatechange='dataStateChange'>
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel'
            :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel" />
          <base-button-responsive v-if="hasModuleImportaciones && !isRoleUserOrConsulta" mode='primary' 
            :text="$t('app.import')" icon='import' @click='toggleImportProductos' 
            :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive mode="primary" :text="$t('products.new')" icon="plus"
            @click="goToNewImpuesto" :loading="isGeneralLoading" />
        </template>
      </base-footer>
      <base-table-select-actions-expand :visibility="hasSelected" :selected="rowsSelected" :total="rowsTotal" :baseDropDownVisible="getAccionesPosibles.length > 0">
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" />
              {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <Dialog :title="$t('products.delete_products')" :visible.sync="showModal" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessagedeleteProducto
        }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
              @click="() => { deleteHandler(); showModal = false }" />
          </div>
        </template>
      </Dialog>
      <import-generic-dialog
        :dialogOpen="showModalImportProductos"
        @toggleDialog="toggleImportProductos"
        @applyDialog="applyImportProductos"
        @downloadTemplate="downloadTemplateProductos"
        :header="$t('imports.import_productos_header')" 
        />
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog :numberSearches="numberSearches" :idVista="idVista" :dialogOpen="saveSearchDialog"
        :tags="tags" @toggleDialog="toggleDialogSearches" @applyDialog="applySearchHandler" />
      <filter-panel-searches ref="filterPanelSearches" :idVista="idVista" :vuexnamespace="vuexnamespace"
        :panelOpen="searchesPanel" @togglePanel="toggleSearchesDialog" @applyFilters="applyFiltersHandler"
        @updateNumberSearches="updateNumberSearches" />
    </template>
  </list-layout>
</template>

<script>
import { bus } from '@/main'
import { i18n } from '@/i18n'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import { Dialog } from 'element-ui'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/ProductsFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'

import { getProductsPag } from '@/services/configurations/getProductsPag'
import { getProductsExcel } from '@/services/configurations/getProductsExcel'
import { deleteProduct } from '@/services/configurations/deleteProduct'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'

// Imports
import ImportGenericDialog from '@/components/ImportGenericDialog.vue'
import { importProductos } from '@/services/configurations/imports/importProductos'
import { downloadTemplateProductos } from '@/services/configurations/imports/downloadTemplateProductos'

export default {
  name: 'vista-productos',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    KendoGridComponent,
    CreateSearchDialog,
    Dialog,
    ImportGenericDialog,
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 35,
      idVista: 66,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // Import
      showModalImportProductos: false,
      // All
      loadingExcel: false,
      spanish: true,
      showModal: false,
      header: {
        title: i18n.t('products.header'),
        icon: 'productos',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'products',
      hasClientFilterData: false,
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      listaAcciones: [
        { IdAccion: 0, Descripcion: 'Borrar' }
      ],
      processMessagedeleteProducto: i18n.t('app.delete_selected_confirmation', { entity: i18n.t('products.header').toLowerCase() }),
    }
  },
  computed: {
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    hasModuleImportaciones () {
      return this.$store.getters['auth/hasImportacionesModule']
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterNav']
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    selectIcon: function (action) {
      return (action) =>
        action === 0 ? 'trash'
          : 'unlink'
    },
    getAccionesPosibles () {
      const listaAccionesFinal = this.listaAcciones.slice()
      return listaAccionesFinal
    },
  },
  watch: {
    $route (to, from) {
      this.updateOnRouteChange(to, from)
      // this.routerChangeHandler()
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
  },
  created: async function () {
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    if (this.actualFilterNav && this.isClientFilterActive && !this.hasClientFilterData) {
      const filter = this.masterFilters
      filter.empresa = { label: i18n.t('clients.entity_name'), value: this.actualFilterNav }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
    }
    this.data = await this.applyFilters()
  },
  methods: {
    toggleImportProductos () {
      this.showModalImportProductos = !this.showModalImportProductos
    },
    applyImportProductos: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importProductos(file, { idCliente: form.idCliente })
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.toggleImportProductos() 
          this.doFeedback(i18n.t('imports.processing'), 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateProductos: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateProductos()
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.downloadBlob(response, 'plantilla-importacion-productos.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            this.hasClientFilterData = true
            const cliente = { label: i18n.t('clients.entity_name'), value: { Nombre: filter.data.label, idCliente: filter.data.id } }
            filters.empresa = cliente
          } else {
            filters[filter.type] = filter.data
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    openPath: function (event) {
      this.$router.push({ name: 'masters/products/details', params: { id: event.dataItem.idProducto } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        ItemDescription: data.ItemDescription ? data.ItemDescription.value : null,
        UnitOfMeasure: data.UnitOfMeasure ? data.UnitOfMeasure.value : null,
        UnitPriceWithoutTaxMin: data.UnitPriceWithoutTaxMin ? data.UnitPriceWithoutTaxMin.value : null,
        UnitPriceWithoutTaxMax: data.UnitPriceWithoutTaxMax ? data.UnitPriceWithoutTaxMax.value : null,
        ArticleCode: data.ArticleCode ? data.ArticleCode.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
        const payload = { order: objOrder.order, grupos: objColumnas }
        if (this.hasSelected) {
          payload.listaIDs = this.selected
        }
        const response = await getProductsExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'productos.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    updateOnRouteChange: async function (to, from) {
      await this.applyFilters()
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      const params = {
        ItemDescription: data.ItemDescription ? data.ItemDescription.value : null,
        UnitOfMeasure: data.UnitOfMeasure ? data.UnitOfMeasure.value : null,
        UnitPriceWithoutTaxMin: data.UnitPriceWithoutTaxMin ? data.UnitPriceWithoutTaxMin.value : null,
        UnitPriceWithoutTaxMax: data.UnitPriceWithoutTaxMax ? data.UnitPriceWithoutTaxMax.value : null,
        ArticleCode: data.ArticleCode ? data.ArticleCode.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      }
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.Respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getProductsPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    unselect: function () {
      this.selected = []
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 0) { // borrar
        this.deleteProduct()
      } else {
        console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
      }
    },
    deleteProduct: async function () {
      this.showModal = !this.showModal
    },
    goToNewImpuesto: function () {
      this.$router.push({ name: 'masters/products/details', params: { id: -1 } })
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idProductos: this.selected || []
        }
        const response = await deleteProduct(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.unselect()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>
